import ModalForm from "./Form";
import { PAYMENT_STATUS, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
    components: { ModalForm },

    data() {
        return {
            DATATABLE_EXPORT,
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: this.ENDPOINT,
            tableId: "payment-status-table",
            rowData: {},
            formId: "payment-status-form",
            tableColumns: [
                {
                    title: "ID",
                    type: "text",
                    key: "payment_status_id",
                },
                {
                    title: "Code",
                    type: "text",
                    key: "payment_status_code",
                },
                {
                    title: "Desc",
                    type: "text",
                    key: "payment_status_desc",
                },
            ],
            ENDPOINT: PAYMENT_STATUS,
            actionObj: {
                title: this.$t("action"),
                type: "action",
            },
            options: {
                name: "PaymentStatus",
                url: PAYMENT_STATUS,
                showHeader: true,
                enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [],
                actions: [
                    {
                        title: this.$t("edit"),
                        icon: "edit",
                        type: "none",
                        component: "app-add-modal",
                        modalId: "payment-status-form",
                    },
                    {
                        title: this.$t("delete"),
                        icon: "trash",
                        type: "none",
                        component: "app-confirmation-modal",
                        modalId: "demo-delete",
                    },
                ],
                filters: [
                    {
                        title: this.$t("is_active"),
                        type: "checkbox",
                        key: "is_active",
                        option: [
                            { id: true, value: "Active" },
                            { id: false, value: "Inactive" },
                        ],
                    },
                ],
                showFilter: true,
                showSearch: true,
                showCount: true,
                showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: "desc",
                actionType: "default",
            },
        };
    },
    methods: {
        /**
         * Delete confirmed $emit Form confirmation modal
         */
        onDelete() {
            let url = `${this.ENDPOINT}/${this.rowData.id}`;
            this.deleteLoader = true;
            this.axiosDelete(url)
                .then((response) => {
                    this.deleteLoader = false;
                    $("#demo-delete").modal("hide");
                    this.onCancelDelete();
                    this.$toastr.s(response.data.message);
                    // this.searchAndSelectFilterOptions();
                })
                .catch(({ err }) => {})
                .finally(() => this.$hub.$emit(`reload-${this.tableId}`));
        },
        onCancelDelete() {
            this.deleteConfirmationModalActive = false;
            this.reSetData();
        },
        reSetData() {
            this.rowData = {};
            this.selectedUrl = "";
        },
    },
};
